import mobileMountingComponent from '../../helpers/component-installer';
import VueFactory from '../../helpers/vueFactory';

export default function (resultPage, luggageDelivery, hideMenu) {
  const CalcPIPWithImportView = () => import(
    /* webpackChunkName: "CalcPIPWithImportView" */
    '../../components/CalculatorPIP/CalcPIPWithImportView.vue'
  );
  CalcPIPWithImportView().then((module) => {
    const $calculatorMapModalContainer = document.createElement('div');
    $calculatorMapModalContainer.setAttribute('id', 'calculatorMapModalContainer');
    document.body.appendChild($calculatorMapModalContainer);

    mobileMountingComponent('#calculator')
      .then(() => {
        VueFactory(module.default, {
          el: '#calculator',
          data: {
            googlePlayLink: 'https://redirect.appmetrica.yandex.com/serve/243159829080772274?click_id={parcel_created}',
            appStoreLink: 'https://redirect.appmetrica.yandex.com/serve/747555869494902530?click_id={parcel_created}',
            huaweiLink: ' https://appgallery.huawei.com/#/app/C103283299',
            qrCodeImageSrc: 'https://storage.yandexcloud.net/boxberrysite-public/img/qr-code.svg',
          },
        }, {},
        {
          resultPage,
          luggageDelivery,
          hideMenu,
        });
      });
  });
}
